import { useFieldValue } from './useFieldValue';
import type { FieldComponentProps } from '@/data/registry';

export function StringField({
  object,
  field,
  label,
  placeholder,
}: FieldComponentProps<string> & {
  placeholder?: string;
}) {
  const value = useFieldValue(object, field);

  return (
    <label className="mt-1.5 grid grid-cols-[84px_1fr] items-center gap-2 text-[0.78rem] leading-tight">
      <span className="truncate text-[0.68rem] font-medium tracking-[0.04em] text-white/65">
        {label}
      </span>
      <input
        className="h-7 rounded-md border border-white/12 bg-[#0d1928e6] px-2.5 text-[0.76rem] text-white transition-colors outline-none placeholder:text-white/30 focus:border-white/30"
        value={value}
        placeholder={placeholder}
        onChange={event => {
          const nextValue = event.target.value;
          object.set(field, nextValue);
        }}
      />
    </label>
  );
}
